import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePasswordComponent } from './components/changepassword/changepassword.component';
import { ContactComponent } from './components/contact/contact.component';
import { FaqComponent } from './components/faq/faq.component';
import { HowTosComponent } from './components/howtos/howtos.component';
import { LoginComponent } from './components/login/login.component';
import { ForgotPasswordComponent } from './components/forgotpassword/forgotpassword.component';
import { ForgotUsernameComponent } from './components/forgotusername/forgotusername.component';
import { PrivacyPolicyComponent } from './components/privacypolicy/privacypolicy.component';
import { RegisterComponent } from './components/register/register.component';
import { SecurityPolicyComponent } from './components/securitypolicy/securitypolicy.component';
import { TermsAndConditionsComponent } from './components/termsandconditions/termsandconditions.component';
import { WebAccessibilityComponent } from './components/webaccessibility/webaccessibility.component';
import { LogoutWarningComponent } from './components/logoutwarning/logoutwarning.component';
import { RouterModule } from '@angular/router';
import { BaseLayoutModule } from '../layout/base-layout.module';
import { CommonLibraryModule } from 'epay-library';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { EmployerFAQComponent } from './components/faq/employer-faq/employer-faq.component';
import { CreditCardCancelComponent } from './components/creditcard/creditcard-cancel/creditcard-cancel.component';
import { CreditCardSuccessComponent } from './components/creditcard/creditcard-success/creditcard-success.component';
import { CreditCardComponent } from './components/creditcard/creditcard.component';
import { NcpFAQComponent } from './components/faq/ncp-faq/ncp-faq.component';
import { CreditCardSuccessCommonComponent } from './components/creditcard/creditcard-success/credit-card-success-common/credit-card-success-common.component';
import { SmiPayIFrameComponent } from './components/creditcard/smi-pay-iframe/smi-pay-iframe.component';

@NgModule({
  declarations: [
    ChangePasswordComponent,
    ContactComponent,
    FaqComponent,
    HowTosComponent,
    LoginComponent,
    PrivacyPolicyComponent,
    RegisterComponent,
    SecurityPolicyComponent,
    TermsAndConditionsComponent,
    WebAccessibilityComponent,
    LogoutWarningComponent,
    ForgotPasswordComponent,
    ForgotUsernameComponent,
    EmployerFAQComponent,
    NcpFAQComponent,
    CreditCardComponent,
    CreditCardSuccessComponent,
    CreditCardCancelComponent,
    CreditCardSuccessCommonComponent,
    SmiPayIFrameComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    BaseLayoutModule,
    CommonLibraryModule,
    MatExpansionModule,
    MatCardModule,
  ],
  exports: [
    ChangePasswordComponent,
    ContactComponent,
    FaqComponent,
    HowTosComponent,
    LoginComponent,
    PrivacyPolicyComponent,
    RegisterComponent,
    SecurityPolicyComponent,
    TermsAndConditionsComponent,
    WebAccessibilityComponent,
    LogoutWarningComponent,
    CreditCardComponent,
    CreditCardSuccessComponent,
    CreditCardCancelComponent,
    SmiPayIFrameComponent,
  ],
})
export class CommonEpayModule {}
